import React from 'react';

import PropTypes from 'prop-types';

import { Text } from 'apps/auth/components/common/Text/Text';
import GaArrows from 'apps/auth/components/ga/accounts/exchange/GaArrows';
import { getLocalizedFormattedAmount } from 'apps/auth/helpers/formats';

import { CurrencyPanel } from './CurrencyPanel';

const ExchangeInfoPanel = (props) => {
    const renderPocketBalance = () => {
        return props.pocketBalance
            ? (props.pocketBalance - props.amountField.value)?.toFixed(2)
            : (props.currencies?.find((c) => c.pocketCurrency?.ncode === props.currency?.ncode)?.balance + Number(props.amountField.value))?.toFixed(2);
    };

    const showNewBalance = () => {
        if (props.pocketBalance && props.pocketBalance - props.amountField.value < 0) {
            return null;
        }
        return (
            <>
                <Text size="secondary" color="secondary" variant="div">
                    {props.newBalanceText}
                </Text>
                <Text size="secondary" color="secondary">
                    {getLocalizedFormattedAmount(props.lang, props.country, renderPocketBalance())}
                    <Text size="secondary" color="secondary" smallCaps>{` ${props.currency?.code}`}</Text>
                </Text>
            </>
        );
    };

    return (
        <>
            {!props.amountField.isError && !props.amountField.value && (
                <CurrencyPanel
                    currencies={props.currencies}
                    currency={props.currency}
                    ccyField={props.ccyField}
                    onSelectCurrencyClick={props.onSelectCurrencyClick}
                    isExchange
                    getCurrencyIcon={props.getCurrencyIcon}
                    onIconRenderError={props.onIconRenderError}
                />
            )}
            {props.amountField.isError && (
                <Text size="secondary" color="error">
                    {props.amountField.errorMessage}
                </Text>
            )}
            {props.displayArrows && <GaArrows />}
            {!props.amountField.isError && props.amountField.value > 0 && showNewBalance()}
        </>
    );
};

ExchangeInfoPanel.propTypes = {
    currencies: PropTypes.array,
    currency: PropTypes.object,
    ccyField: PropTypes.object.isRequired,
    newBalanceText: PropTypes.string,
    pocketBalance: PropTypes.number,
    amountField: PropTypes.object.isRequired,
    displayArrows: PropTypes.bool,
    restriction: PropTypes.object,
    onSelectCurrencyClick: PropTypes.func.isRequired,
};

export default ExchangeInfoPanel;
